import React, { useState } from "react";
import "./Auth.scss";
import HalfSplashScreen from "./HalfSplashScreen";
import { useFormik } from "formik";
import Api from "../../api";
import ErrorInfoBox from "../common/ErrorInfoBox";
import useLoader from "../../utils/useLoader";
import Button from "../common/Button";

function Login() {
  const [error, setError] = useState({ title: "", message: "" });
  const { isLoading, setIsLoading } = useLoader();

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Email address is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "You have entered an invalid email address";
    }

    if (!values.password) {
      errors.password = "Password is required";
    } else if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/i.test(values.password)) {
      errors.password =
        "Your Password must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: async (values) => {
      setIsLoading(true);
      const response = await Api.Firebase.Auth.login(
        values.email,
        values.password
      );
      if (response && !response.success) {
        setError(response.code);
        setIsLoading(false);
        return;
      }
      setIsLoading(false);

      window.location.reload();
    },
  });

  return (
    <div className="auth-login-container">
      <div className="auth-login-form">
        <h1>Login</h1>
        <ErrorInfoBox title={error.title} message={error.message} />
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="email">
            Email<span className="input-required">*</span>
          </label>
          <input
            id="email"
            name="email"
            type="email"
            disabled={isLoading}
            onChange={formik.handleChange}
            value={formik.values.email}
          />
          {formik.errors.email ? (
            <div className="input-error-message">{formik.errors.email}</div>
          ) : null}

          <label htmlFor="password">
            Password<span className="input-required">*</span>
          </label>
          <input
            id="password"
            name="password"
            type="password"
            disabled={isLoading}
            onChange={formik.handleChange}
            value={formik.values.password}
          />
          {formik.errors.password ? (
            <div className="input-error-message">{formik.errors.password}</div>
          ) : null}

          <Button type="submit" isLoading={isLoading} label="Login" />
        </form>
      </div>
      <HalfSplashScreen />
    </div>
  );
}

export default Login;
